import { MapAreaData } from "@shared/components/map/map-styles.model";

export enum MapAreaType {
    District = 'district',
    Municipality = 'municipality',
    Region = 'region'
}

export interface MapAreaClickedEvent {
    elementId?: string;
    areaType?: MapAreaType;
    data?: MapAreaData
}
